import React from 'react';

const ContactInfo = ({ title, name, email, phone, extension }) => {
    if (!name && !email && !phone) return null;
    return (
        <div className='contact-info'>
            {title && <h4 className='page-subtitle'>{title}</h4>}
            <div className='contact-info__items'>
                {name && <div className='contact-info__items__item'>
                    <span className='label'>Name:</span> <span className='value'>{name}</span>
                </div>}
                {(phone || extension) && (<div className='contact-info__items__item'>
                    {phone && (
                        <>
                            <span className='label'>Phone:</span> <span className='value'>{phone}</span>
                        </>
                    )
                    }
                    {extension && (
                        <>
                            <span className='ml-10'>Extension </span> <span className='value ml-5'>{extension}</span>
                        </>
                    )
                    }
                </div>
                )
                }
                {email && <div className='contact-info__items__item'>
                    <span className='label'>Email:</span> <span className='value'>{email}</span>
                </div>}
            </div>
        </div>
    );
}

export default ContactInfo;